export default __webpack_public_path__ + "static/B0092-ec34fa94f711810c7e1676c5781c4d6e.png";